import React from "react";
import "./NewsLetter.css";

const NewsLetter = () => {
  return (
    <section className="lux-newsletter">

      {/* GLOWS */}
      <span className="lux-news-glow lux-news-glow-left"></span>
      <span className="lux-news-glow lux-news-glow-right"></span>

      <div className="lux-news-container">
        <span className="lux-eyebrow">STAY CONNECTED</span>

        <h1 className="lux-news-title">
          Get <span>Exclusive Offers</span><br />On Your Email
        </h1>

        <p className="lux-news-desc">
          Subscribe to Prime Cosmo newsletter and never miss premium deals.
        </p>

        <form className="lux-news-form">
          <input
            type="email"
            placeholder="Enter your email address"
          />
          <button type="submit">Subscribe</button>
        </form>
      </div>

    </section>
  );
};

export default NewsLetter;
